import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.scss']
})
export class QuizComponent implements OnInit {

  constructor() { }

  @Input() question = "";
  @Input() answers = [];
  @Input() language = "";

  answer: string | boolean = "";
  correct: boolean = false;
  incorrect: boolean = false;
  status: string = "";

  ngOnInit(): void { }

  submitAnswer(answer: boolean) {
    if (answer == true) {
      this.correct = true;
      if (this.language == "en") {
        this.status = "Correct!";
      } else {
        this.status = "Correcto!";
      }
    } else {
      this.incorrect = true;
      if (this.language == "en") {
        this.status = "Incorrect";
      } else {
        this.status = "Incorrecto";
      }
    }
  }

}
